import { getApiUserGender } from "./getApiUserGender";
import { getApiUserRelationship } from "./getApiUserRelationship";
import { getApiUserService } from "./getApiUserService";

export function userController() {
  return { getApiUserGender, getApiUserRelationship, getApiUserService };
}
